<div class="maps-iframe-generic">
  <iframe *ngIf="loaded" [src]="this.src" style="width: 100%; height: 100%;" allowfullscreen></iframe>
</div>